import React, { Component } from 'react'
import {
    Grid,
    Row,
    Col
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { orderActions } from "../../../redux/actions/order-actions";
import { createOrderActions } from "../../../redux/actions/create-order-actions";
import OrderDetailForm from './OrderDetailForm';
import ViewOrderProductsList from './ViewOrderProductsList';

class OrderDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order_id: this.props.match.params.id,
            order: null,
            shippingAddress: {
                shipping_option: '',
                shipping_account_no: '',
                print_location: '',
                print_currency: '',
                special_instructions: '',
                address: {
                    country_id: '',
                    country: ''
                }
            },
            billingAddress: {
                shipped_date: new Date(),
                tracking_number: '',
                billing_status: '',
                comments: '',
                address: {
                    country_id: '',
                    country: ''
                }
            },
            states: [],
            checked: false,
            submitted: false,
            selectedBrand: null,
            selectedTaglayout: null,
            cart: null,
            filtered: "",
            cartProductspageSize: 100,
            productsData: [],
            page: 1
        }

        this.child = React.createRef();
    }

    componentDidMount = () => {
        this.props.getOrderDetails(this.state.order_id).then(response => {
            this.setState({ order: this.props.order });
        });
    }

    productsPaginationData = (page, filter, sort, pageSize) => {
        this.setState({ cartProductspageSize: pageSize, page: page }, function () {
            this.props.getOrderProductsCall({ order_id: this.state.order_id, page, pageSize }).then(response => {
                this.setState({
                    ...this.state,
                    productsData: this.props.productsData
                });
            });
        });
    };

    render() {
        return (
            <React.Fragment>
                {this.state.order != null &&
                    <React.Fragment>
                        <OrderDetailForm
                            hasShippingAddresses={true}
                            hasBillingAddresses={true}
                            productAttributes={this.state.productAttributes}
                            orderAttributes={this.state.orderAttributes}
                            selectedTaglayout={this.state.selectedTaglayout}
                            selectedBrand={this.state.selectedBrand}
                            cart={this.props.cartInfo}
                            filterAttributes={this.state.filterAttributes}
                            selectedFilterAttributes={
                                this.state.selectedFilterAttributes
                            }
                            orderDetailsProp={this.state.order}
                            showViewCart="false"
                            fromCartPage="false"
                            canChangeStatus="true"
                        />

                        <Grid fluid>
                            <Row>
                                <Col md={12}>
                                    <Card
                                        ctTableResponsive
                                        content={
                                            <div>
                                                <Grid fluid>
                                                    <Row>
                                                        <Col md={12}>

                                                            <div className="col-md-6" style={{ float: 'left' }}>
                                                                <div className="flexElem alignCenter spaceBetween">
                                                                    <div>
                                                                        <h4>Order Products</h4>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <ViewOrderProductsList
                                                                productsData={this.state.productsData}
                                                                productAttributesProp={this.props.order.productAttributes}
                                                                orderAttributesProp={this.props.order.orderAttributes}
                                                                exportAttributes={this.props.order.exportAttributes}
                                                                cart={this.props.cart}
                                                                productsPaginationData={this.productsPaginationData}
                                                                pageSize={this.state.cartProductspageSize}
                                                                filtered={this.state.filtered}
                                                                pages={this.props.pages}
                                                                loading={this.props.loading}
                                                                deleteProductFromCart={this.deleteProductFromCart}
                                                                changeHandler={this.changeHandler}
                                                                ref={this.child}
                                                                order_id={this.state.order_id}
                                                            // selectedFilterAttributes={this.props.selectedFilterAttributes}
                                                            // filterAttributes={this.props.filterAttributes}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Grid>
                                            </div>} />
                                </Col>
                            </Row>
                        </Grid>
                    </React.Fragment>
                }

            </React.Fragment>
        )
    }
}
const mapDispatchToProps = dispatch => {
    return ({
        getOrderDetails: custId => {
            return dispatch(orderActions.getOrder(custId));
        },
        getOrderProductsCall: (data) => {
            return dispatch(createOrderActions.getOrderProductsPagination(data));
        },
    });
};

function mapStateToProps(state) {
    const { order } = state.ordersReducer;

    const {
        productsData,
        pages,
        current_page,
        total_orders
    } = state.createOrdersReducer;

    return {
        order,

        productsData,
        pages,
        current_page,
        total_orders
    };
}

const OrderDetail = connect(mapStateToProps, mapDispatchToProps)(OrderDetails);
export default withRouter(OrderDetail);



// WEBPACK FOOTER //
// ./src/components/Admin/Order/OrderDetails.jsx